var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TokenInfo } from "./TokenInfo";
import { AdditionalInfo } from "./AdditionalInfo";
export class MalteseAdditionalInfo extends AdditionalInfo {
  constructor(_data) {
    super();
    /**
     */
    __publicField(this, "SubmissionToken");
    /**
     */
    __publicField(this, "SubscriptionKey");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof MalteseAdditionalInfo
     */
    __publicField(this, "$type", "V1.Cesop.Psps.Extensions.MalteseAdditionalInfo");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    super.init(_data);
    if (_data) {
      if (_data["SubmissionToken"]) {
        const submissionToken_ = new TokenInfo();
        this.SubmissionToken = submissionToken_.init(_data["SubmissionToken"]);
      }
      this.SubscriptionKey = _data["SubscriptionKey"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    super.toJSON(_data);
    _data["SubmissionToken"] = this.SubmissionToken ? this.SubmissionToken.toJSON() : void 0;
    _data["SubscriptionKey"] = this.SubscriptionKey;
    return _data;
  }
}
